export enum SPOTCompletionStatus {
  Yes = 'Yes',
  No = 'No',
  NotEarlyChildhoodClassroom = 'NotEarlyChildhoodClassroom'
}

export const spotCompletionStatusLabels: Record<SPOTCompletionStatus, string> = {
  [SPOTCompletionStatus.Yes]: 'Yes',
  [SPOTCompletionStatus.No]: 'No',
  [SPOTCompletionStatus.NotEarlyChildhoodClassroom]: 'No, not an Early Childhood Classroom'
}
